import React__default, { useState } from 'react';
import { F as FormStateContext } from './FormStageContext-CEDzLzYf.js';

const getStage = ({
  isIntroVisited,
  isMobile,
  isSubmitSuccessful,
  withoutConfirmation
}) => {
  if (isSubmitSuccessful && !withoutConfirmation) {
    return 'submitted';
  }
  return isMobile && !isIntroVisited ? 'intro' : 'notSubmitted';
};
const FormStageProvider = ({
  children,
  isIntroSkipped = false,
  isMobile,
  isSubmitSuccessful,
  withoutConfirmation
}) => {
  const [isIntroVisited, setIsIntroVisited] = useState(() => isIntroSkipped);
  React__default.useEffect(() => {
    setIsIntroVisited(prevIsIntroVisited => prevIsIntroVisited || isIntroSkipped);
  }, [isIntroSkipped]);
  const onIntroVisited = () => {
    setIsIntroVisited(true);
  };
  const stage = getStage({
    isIntroVisited,
    isMobile,
    isSubmitSuccessful,
    withoutConfirmation
  });
  return /*#__PURE__*/React__default.createElement(FormStateContext.Provider, {
    value: {
      stage,
      onIntroVisited
    }
  }, children);
};

export { FormStageProvider as F };
//# sourceMappingURL=FormStageProvider-CItwRlDn.js.map
